import { render } from "./icon-gr-block.svg?vue&type=template&id=077367cc?inline"
const script = {}
script.render = render

export default script